import { useEffect, useState } from "react";
import TransactionServices from "../TransactionServices";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function Matching_Format(param: any) {
    console.log(param)

    let pagination = { pageNumber: 1, pageSize: 10 }
    let [linkedAll, setLinkedAll] = useState(false);
    let [deleteData, setDeleteData] = useState<any>([]);
    let [filterFormats, setFilterFormats] = useState("");
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [formatAlias, setFormatAlias] = useState<any[]>([]);
    let [select_Formats, setselect_Formats] = useState<any>([]);
    let [formatCodeList, setFormatCodeList] = useState<any>([]);
    let [saveAlertFormats, setAaveAlertFormats] = useState(false);
    let [formatAliasTemp, setFormatAliasTemp] = useState<any[]>([]);
    let [formatAlias_ourCode, setformatAlias_ourCode] = useState("");
    let [formatAlias_accountCode, setformatAlias_accountCode] = useState("");
    let [filteredUnmatchedData, setfilteredUnmatchedData] = useState<any>([]);
    let [factSalesRawAccountCode, setFactSalesRawAccountCode] = useState<any>([]);
    let [filteredUnmatchedDataTemp, setfilteredUnmatchedDataTemp] = useState<any>([]);


    useEffect(() => {
        select_Formats = []
        setselect_Formats(select_Formats)
        api_call();
    }, []);

    const api_call = () => {

        TransactionServices.getCodingStr({}).then((respond: any) => setFormatCodeList(respond))

        TransactionServices.getFactSalesRawAccountCode({}).then((respond: any) => setFactSalesRawAccountCode(respond))
    };

    const formatalias = () => {
        TransactionServices.getFormatAlias({}).then((res: any) => {

            formatAliasTemp = res?.filter((FAT: any) => FAT.accountCode == formatAlias_accountCode)
            setFormatAliasTemp(formatAliasTemp)

            formatAlias = formatAliasTemp?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
            setFormatAlias(formatAlias)
        })
    };

    const onChangeAccountCode = (e: any) => {

        formatAlias = []
        setFormatAlias(formatAlias)

        formatAliasTemp = []
        setFormatAliasTemp(formatAliasTemp)

        formatAlias_accountCode = e;
        setformatAlias_accountCode(formatAlias_accountCode)
        TransactionServices.getFactSalesRawSubInfoByAccountCode(e).then((respond: any) => {
            filteredUnmatchedData = respond?.subInfo
            setfilteredUnmatchedData(filteredUnmatchedData)
        })
    };

    const handleFormatAlias = (e: any) => {
        pagination.pageNumber = e.pageNumber;
        pagination.pageSize = e.pageSize;

        formatAlias = formatAliasTemp?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setFormatAlias(formatAlias)
    };

    const formatSave = () => {
        if (formatAlias_accountCode?.length == 0 || formatAlias_ourCode?.length == 0 || select_Formats?.length == 0) {
            CommonUtilities.showToastDawer("Check at least one unmatched format to associate and fill in the required fields", 'fail');
        } else {

            console.log(select_Formats)
            var formatAlias_list = []
            for (var i = 0; i < select_Formats.length; i++) {
                formatAlias_list.push({
                    accountCode: formatAlias_accountCode,
                    id: filteredUnmatchedData[select_Formats[i]]?.id,
                    ourCode: select_Formats,
                    subContent: filteredUnmatchedData[select_Formats[i]]?.subContent,
                    subFormat: filteredUnmatchedData[select_Formats[i]]?.subFormat,
                    subProvider: filteredUnmatchedData[select_Formats[i]]?.subFormat,
                    theirCode: null
                })
                console.log(formatAlias_list)
            }

            //TransactionServices.saveFormatAlias(formatAlias_accountCode)
        }

    };

    const onMatchFormatsClear = () => {
        formatAlias_accountCode = ''
        setformatAlias_accountCode(formatAlias_accountCode)

        formatAlias_ourCode = ''
        setformatAlias_ourCode(formatAlias_ourCode)

        filteredUnmatchedData = []
        setfilteredUnmatchedData(filteredUnmatchedData)
        api_call();
    };

    const onMatchFormatsRefresh = () => { onChangeAccountCode(formatAlias_accountCode) }

    const matchingFormatsExport = (e: any) => { TransactionServices.getFactSalesRawSubInfoByAccountCodeExport(e) }

    const removeformatAlias = (e: any) => {
        deleteData = e;
        setDeleteData(deleteData)
        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    };

    const selectAllFormats = (e: any) => {

        console.log(typeof (e))
        console.log(linkedAll)
        if (typeof (e) == "string" && !linkedAll) {
            for (var i = 0; i < filteredUnmatchedData.length; i++) {
                console.log(i)
                console.log(select_Formats)
                console.log(select_Formats.includes(i))
                if (!select_Formats.includes(i)) {
                    select_Formats = [...select_Formats, i];
                    setselect_Formats(select_Formats);
                }

                console.log(select_Formats)
            }
        }

        if (typeof (e) == "string" && linkedAll) {
            select_Formats = []
            setselect_Formats(select_Formats);
        }


        if (typeof (e) == "number") {
            if (!select_Formats.includes(e)) {
                setselect_Formats((prev: any) => [...prev, e]);
            }

            if (select_Formats.includes(e)) {
                setselect_Formats(
                    select_Formats.filter((item: any) => item !== e)
                );
            }
        }
    };

    const check_box = (e: any) => {
        var check_status = false
        var foundSTS = select_Formats?.filter((selectFormat: any) => selectFormat == e)
        if (foundSTS?.length > 0) { check_status = true }
        return check_status;
    };

    const Confirmation = (e: any) => {
        console.log(e)
        if (e === 1) {
            TransactionServices.deleteFormatAlias(deleteData).then(() => {
                formatalias()
                CommonUtilities.showToastDawer("Format has been deleted successfully", 'Success');
            })
        }

        deleteStatus = false;
        setDeleteStatus(deleteStatus)
    };

    const exportFormats = function (el: any) {
        const data: any = {};

        if (formatAliasTemp?.length > 0) {
            data['Unmatched formats'] = {
                headers: ['Sub Content', 'Sub Format', 'Sub Provider'],
                rows: formatAliasTemp.map((item: any) => [
                    item.subContent,
                    item.subFormat,
                    item.subProvider
                ])
            };
        }

        if (formatAliasTemp?.length > 0) {
            data['Format aliases'] = {
                headers: [
                    'Format To Report',
                    'Sub Format',
                    'Sub Content',
                    'Sub Provider',
                    'Account Code'
                ],
                rows: formatAliasTemp.map((item: any) => [
                    item.ourCode,
                    item.subFormat,
                    item.subContent,
                    item.subProvider,
                    item.accountCode
                ])
            };
        }

        console.log(data);
        //var base64Data = Excel.tableToBase64(data);
        //commonUtils.saveBase64toExcel(base64Data, 'ExistingFormatAliases.xls');


    };

    const filter_Formats = (e: any) => {
        filterFormats = e
        setFilterFormats(filterFormats)

        const filteredData = !e
            ? formatAliasTemp
            : formatAliasTemp?.filter((fat: any) =>
                fat.subContent?.includes(e) ||
                fat.subFormat?.includes(e) ||
                fat.subProvider?.includes(e)
            );


        formatAlias = filteredData?.slice(
            (pagination.pageNumber - 1) * pagination.pageSize,
            pagination.pageNumber * pagination.pageSize
        );
        setFormatAlias(formatAlias)
    };

    return (
        <>
            <div className="ws-12 allowHscroll allowVscroll">

                <div className="ws-12 box mbl borderRounded">

                    <h2 className="mt mll"> Matching Formats/Source Codes</h2>

                    <div className="box-content">

                        {false && <div className="alert alert-info">Operation queued for processing</div>}
                        {false && <div className="alert alert-info">Re-run this operation after a few mins as similar job already in progress</div>}

                        {false && <div className="alert alert-info">Check at least one unmatched format to associate and fill in the required fields</div>}

                        <div className="form-format ws-6">
                            <label >Account Code*</label>

                            <div className="label-entries">
                                <select title="Choose Account Code" onChange={(e: any) => onChangeAccountCode(e.target.value)} id="accountCode" value={formatAlias_accountCode} name="accountCode" required>
                                    <option value="" >Choose Account Code</option>
                                    {
                                        factSalesRawAccountCode?.map((values: any) => {
                                            return (
                                                <option value={values?.code} label={values?.name}>{values?.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="form-format ws-6">
                            <label >Formats/Source Codes*</label>

                            <div className="label-entries">
                                <select title="Choose Formats/Source Codes Report" value={formatAlias_ourCode} onChange={(e: any) => setformatAlias_ourCode(e.target.value)} id="formatreport" name="formatreport" required>
                                    <option value="" >Choose Formats/Source Codes Report</option>
                                    {
                                        formatCodeList?.map((values: any) => {
                                            return (
                                                <option value={values} label={values}>{values}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        {formatAlias_accountCode.length == 0 && <div className="alert alert-info m0 "> Select an account code</div>}

                        {filteredUnmatchedData?.length == 0 && formatAlias_accountCode.length > 0 && <div className="alert alert-info m0">No unmatched formats for the selected account code                                    </div>}

                        {filteredUnmatchedData?.length > 0 && <div className="box-header well" > <h4 > {filteredUnmatchedData?.length} record(s) found</h4>  </div>}

                        {filteredUnmatchedData?.length > 0 && <table className="newTable">
                            <tbody>
                                <tr>
                                    <th><input type="checkbox" onClick={() => selectAllFormats('ALL')} title="Select All Formats" checked={linkedAll} onChange={() => setLinkedAll(!linkedAll)} /></th>
                                    <th >Sub content</th>
                                    <th >Sub Formats/Source Codes</th>
                                    <th >Sub provider</th>
                                </tr>

                            </tbody>
                            <tbody>
                                {
                                    filteredUnmatchedData?.map((values: any, index: any) => {
                                        return (<tr>
                                            <td ><input type="checkbox" onClick={() => selectAllFormats(index)} title="Select All Formats" checked={check_box(index) == true} />{values?.subContent}</td>
                                            <td >{values?.subContent}</td>
                                            <td >{values?.subFormat}</td>
                                            <td >{values?.subProvider}</td>
                                        </tr>)
                                    })
                                }
                            </tbody>
                        </table>}

                        <div className="clearfix">

                        </div>


                    </div>

                    <div className="box-footer">

                        <button className="icon-btn edit" title="Unmatched Formats for all Account Code" onClick={() => matchingFormatsExport("ALL")}> <i className="icon-download1"></i> </button>

                        {formatAliasTemp.length > 0 && <button className="icon-btn edit" title="Unmatched Formats" onClick={() => matchingFormatsExport(formatAlias_accountCode)} > <i className="icon-download1"></i></button>}

                        {formatAlias_accountCode.length > 0 && <button className="btn  icon-btn delete" onClick={onMatchFormatsRefresh}><i className="icon-reload"></i> Refresh  </button>}

                        <button className=" icon-btn delete " onClick={onMatchFormatsClear}>  <i className="icon-refresh"></i>   Reset </button>
                        <button className="icon-btn edit " onClick={formatSave}><i className="icon-save-disk"></i> Save</button>
                    </div>

                </div>

                <div className="ws-12 box mbl borderRounded">

                    <h2 className="mt mll"> Existing Formats/Source Codes Aliases  -{formatAliasTemp.length} record(s) found </h2>

                    <div className="box-content">

                        {saveAlertFormats && <div className="alert alert-info">Format  has been saved successfully</div>}
                        {false && <div className="alert alert-info">Format  has been deleted successfully</div>}

                        {formatAliasTemp.length == 0 && <button className="icon-btn primary mb" onClick={formatalias}>  Load all aliases </button>}

                        {formatAliasTemp.length > 0 && <div className="ws-12">
                            <div className="form-format">
                                <label >Filter</label>
                                <div className="label-entries">
                                    <input type="text" className="form-control input-sm ws-8" placeholder="Search" value={filterFormats} onChange={(e: any) => filter_Formats(e.target.value)} id="formats" />
                                </div>
                            </div>
                        </div>}

                        {formatAliasTemp.length == 0 && filterFormats.length > 0 && <div className="alert alert-info">No records found </div>}

                        {formatAliasTemp.length == 0 && <div className="alert alert-info">No existing format aliases added yet </div>}

                        {formatAliasTemp.length > 0 && <div className="table-ws-12">

                            <table className="newTable">
                                <thead>
                                    <tr>
                                        <th >Format to Report</th>
                                        <th >SubContent</th>
                                        <th >SubFormat</th>
                                        <th >SubProvider</th>
                                        <th >Account Code</th>
                                        <th >Operation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formatAlias?.map(values => {
                                        return (
                                            <tr>
                                                <td>{values.ourCode}</td>
                                                <td>{values.subContent}</td>
                                                <td>{values.subFormat}</td>
                                                <td>{values.subProvider}</td>
                                                <td>{values.accountCode}</td>
                                                <td>
                                                    <a title="Delete" className="icon-btn delete" onClick={() => removeformatAlias(values)}>
                                                        <i className="icon-trashcan"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>

                        </div>}

                        {formatAliasTemp.length > 0 && <div className="clearfix mt">
                            {(() => {
                                if (formatAliasTemp && formatAliasTemp.length > 10) {
                                    return <Pagination onPageChange={handleFormatAlias} totalRow={formatAliasTemp.length} />
                                }
                            })()}
                        </div>}

                        {formatAliasTemp.length > 0 && <button className="btn-success mt hide" onClick={() => exportFormats("dl")}>
                            <i className="icon-download1"></i>
                        </button>}


                    </div>

                </div>
                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={true} message={"delete this territory alias " + deleteData?.ourCode} onChange={Confirmation} />
                        }
                    })()
                }

            </div>
        </>
    )
}